import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import './Blog.scss'

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";

const Blog = () => {
  const [articles, setArticles] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const query = '*[_type == "blog"]';

    client.fetch(query).then((data) => {
      setArticles(data);
    });
  }, []);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };
  const link = "https://medium.com/@robinmelsaw/learn-test-driven-development-tdd-8e1b47ff55f9"
  return (
    <>
      {articles?.length && (
        <>
          <div className="app__blog-item app__flex">
            <div><img src={urlFor(articles[currentIndex]?.imgurl)} alt="article" /></div>
            
            <div className="app__blog-content">
              <h4 className="article-title"><a href={link} target="_blank">{articles[currentIndex]?.title}</a></h4>
              <p className="article-text">{articles[currentIndex]?.article} <a href={link} target="_blank">Read All...</a></p>
            </div>

            
          </div>
          <div className="app__blog-btns app__flex">
              <div
                className="app__flex"
                onClick={() =>
                  handleClick(
                    currentIndex === 0 ? articles.length - 1 : currentIndex - 1
                  )
                }
              >
                <HiChevronLeft />
              </div>

              <div
                className="app__flex"
                onClick={() =>
                  handleClick(
                    currentIndex === articles.length - 1 ? 0 : currentIndex + 1
                  )
                }
              >
                <HiChevronRight />
              </div>
            </div>
        </>
      )}
    </>
  );
};

export default AppWrap(MotionWrap(Blog, "app__blog"), "blog", "app__primarybg");
